import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { DISTRIBUTION_REPORT_API } from "./apiRoutes";

interface UseGetGlMasterProps {
  communityId: string;
  year: string;
  type: "actuals" | "plan";
  filter?: any; 
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getCloseoutGlList = async (communityId: string, year: string, type: "actuals" | "plan", filter?: any) =>
  await axiosAuth.get(
    `${DISTRIBUTION_REPORT_API}/${communityId}/year/${year}/reports/closeout/${type}/gls/options${filter ? `?${new URLSearchParams(filter).toString()}` : ""}`
  );

const useGetCloseoutGlList = ({
  communityId,
  year,
  type,
  filter,
  queryParams,
}: UseGetGlMasterProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["closeout-gl-list", communityId, year, type],
    queryFn: () => getCloseoutGlList(communityId, year, type, filter),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!communityId,
    ...queryParams,
  });
};

export default useGetCloseoutGlList;
